import { __assign, __extends } from "tslib";
import React from "react";
var SVG = /** @class */ (function (_super) {
    __extends(SVG, _super);
    function SVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVG.prototype.render = function () {
        return React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, this.props),
            React.createElement("g", { fill: "currentColor" },
                React.createElement("path", { d: "M8 2a3 3 0 0 0-3 3v1a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3zm0-1a4 4 0 0 1 4 4v1a4 4 0 1 1-8 0V5a4 4 0 0 1 4-4z" }),
                React.createElement("path", { d: "M7.221 10h1.024-1.024zm1.8 0c3.742 0 4.975 1.729 4.975 5h1c0-2.577-.747-6-5.975-6h-1.8v1h1.8zm-.28 0h-.496.496zm-1.764 0c-3.701 0-4.975 1.769-4.975 5h-1c0-2.577.81-6 5.975-6h.244v1h-.244zm1.764 0H7.707h1.034zm-1.52 0h.486-.486zm1.8 0c3.742 0 4.975 1.729 4.975 5h1c0-2.577-.747-6-5.975-6h-1.8v1h1.8zm-2.044 0c-3.701 0-4.975 1.769-4.975 5h-1c0-2.577.81-6 5.975-6h.244v1h-.244z" })));
    };
    return SVG;
}(React.Component));
export default SVG;
